// extracted by mini-css-extract-plugin
export default {"uklon":"MainScreen_uklon__wRItT","eventzone":"MainScreen_eventzone__Zp5JH"};